module.exports = __webpack_public_path__ + "img/image_20.4b327afe.png";